<button type="button" nz-button nzType="text" nzShape="circle" (click)="show()" nzSize="large" [nz-tooltip]="'Stock Journal'" [disabled]="isEmptyId">
    <span nz-icon nzType="book" nzTheme="outline"></span>
</button>
<nz-modal [(nzVisible)]="visible" [nzTitle]="journalTitle" (nzOnCancel)="hide()" nzWidth="1200">
    <ng-template #journalTitle>
        <span>Stock Journal</span>
        @switch (documentStatus) {
        @case (0) {
        <nz-tag [nzColor]="'#FA9D94'" style="margin-left: 8px;">Draft</nz-tag>
        }
        @case (1) {
        <nz-tag [nzColor]="'#f7e9a9'" style="margin-left: 8px;">Waiting for Approval</nz-tag>
        }
        }
    </ng-template>
    <ng-container *nzModalContent>
        <app-scrollable width="300px">
        <st 
        #st [data]="list" 
        [columns]="columns" 
        [body]="bodyTpl" 
        [page]="{ show: false }" 
        bordered="true" 
        responsive="false"
        class="gl-background">
            <ng-template st-row="amountTitleTpl" type="title" let-c>
                <div class="text-right">{{ c.title.text }}</div>
            </ng-template>
            <ng-template st-row="inTpl" let-item let-column="column">
                <div class="text-right" *ngIf="item[column.index]">{{ item[column.index] | price | minusSignToParensPipe }}</div>
            </ng-template>
            <ng-template st-row="outTpl" let-item let-column="column">
                <div class="text-right" *ngIf="item[column.index]">{{ item[column.index] | price | minusSignToParensPipe }}</div>
            </ng-template>
            <ng-template st-row="amountTpl" let-item let-column="column">
                <div class="text-right" *ngIf="item[column.index]">
                    @if(hideUnitCost){
                    <span>*****</span>
                    }@else{
                    <span>{{ item[column.index] | price | minusSignToParensPipe }}</span>
                    }
                </div>
            </ng-template>

            <ng-template #bodyTpl let-s>
                <ng-container *ngIf="st.count > 0">
                    
                </ng-container>
            </ng-template>
        </st>
        </app-scrollable>
    </ng-container>

    <ng-container *nzModalFooter>
        <button type="button" nz-button nzType="primary" (click)="hide()">Close</button>
    </ng-container>
</nz-modal>
  